import dayjs from "dayjs";
import * as _ from "lodash";
import { put, select } from "redux-saga/effects";

import actions from "@/actions";
import { Map } from "@/utils";

/**
 * Detects duplicate VLC/BLE IDs across lights and flags them accordingly.
 *
 * @param lights - The collection of lights to check for duplicates.
 * @param update - Whether to dispatch flag updates to the store.
 * @yields Selects light data and dispatches duplicate flag updates.
 */
function* handleDuplicateFlags(lights, update = true) {
    const positioningTypes = yield select(({ map }) =>
        map.general.settings.fixtureDetails.positioningType.split(" + "),
    );

    _.each(lights, (light) =>
        _.remove(
            light.selectedFlags,
            (flag) => flag.value === 16 || flag.value === 32,
        ),
    );

    _.each(positioningTypes, (positioningType) => {
        const positioningTypeProp = {
            name: _.toLower(positioningType) === "vlc" ? "id" : "bleId",
            flag: _.find(
                Map.Collections.flags,
                (flag) =>
                    flag.value ===
                    (_.toLower(positioningType) === "vlc" ? 16 : 32),
            ),
        };

        const lightsMatchingGroups = _.groupBy(
            lights,
            (light) => light[positioningTypeProp.name],
        );

        _.each(lightsMatchingGroups, (lightsMatchingGroup, value) => {
            const checkDuplicateFlag = lightsMatchingGroup.length > 1;

            _.each(lightsMatchingGroup, (light) => {
                if (
                    checkDuplicateFlag &&
                    value !== "0" &&
                    _.toInteger(light[positioningTypeProp.name]) !== 0
                ) {
                    light.selectedFlags.push(positioningTypeProp.flag);
                }
            });
        });
    });

    const lightsMethod = update ? "updateLights" : "setLights";

    yield put(actions.map.general.deselectAllLights());
    yield put(actions.map.values.global[lightsMethod](lights));

    const timeStamp = dayjs().format();

    yield put(actions.topBar.updateTimeStamp(timeStamp));
}

export default handleDuplicateFlags;
